module.exports = __webpack_public_path__ + "static/img/adv.95a0ea0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/adv.png
// module id = o6wR
// module chunks = 1